import { FormControl } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

export const ControlledHiddenField = ({ name, defaultValue = '' }) => {
  const { control } = useFormContext()

  return (
    <>
      <FormControl fullWidth size='small'>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { ref, onChange } }) => (
            <input
              ref={ref}
              onChange={onChange}
              style={{
                width: 0,
                height: 0,
                opacity: 0
              }}
            />
          )}
        />
      </FormControl>
    </>
  )
}
